import styled from 'styled-components';

export const ContainerWrapper = styled.div`
  max-width: ${(props) => props.width ?? ''};
  padding: ${(props) => !props.width && '32px'};
  margin-left: auto;
  margin-right: auto;
`;
